<template>
  <div>
    <el-form>
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          @change="getGuide"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getGuide"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <v-distpicker
        style="margin-bottom: 25px"
        v-model="model"
        :province="model.province"
        :city="model.city"
        :area="model.area"
        @province="selectProvince"
        @city="selectCity"
        @area="selectArea"
      ></v-distpicker>
    </el-form>
    <div>
      <template v-show="guData">
        <el-table :data="guData" border style="width: 100%; height: 100%">
          <el-table-column
            prop="createAt"
            label="日期"
            :formatter="formatDate"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="guName" label="标题"> </el-table-column>
          <el-table-column prop="guAuthor" label="来源" width="130">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="270">
            <template slot-scope="scope">
              <el-button
                style="margin: 3px 3px 3px 3px"
                @click="scanGuide(scope.row)"
                type="primary"
                size="small"
                icon="el-icon-view"
                plain
                text
                >查看</el-button
              >

              <el-button
                style="margin: 3px 3px 3px 3px"
                @click="$router.push(`/guide/edit/${scope.row._id}`)"
                type="primary"
                size="small"
                icon="el-icon-edit"
                plain
                text
                >编辑</el-button
              >

              <el-button
                style="margin: 3px 3px 3px 3px"
                @click="delGuide(scope.row)"
                type="danger"
                size="small"
                icon="el-icon-delete"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-skeleton :loading="loading" :rows="10" animated />
    </div>
    <!--  新闻分类分页 -->
    <div style="margin-top: 15px">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="thpre"
        @next-click="thnext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="guDataCount"
      >
      </el-pagination>
    </div>

    <!--   新闻查看弹窗 -->
    <el-dialog
      :title="viewguide.guName"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="65%"
    >
      <div>{{ viewguide.guAuthor }}</div>
      <div v-html="viewguide.guBody"></div>
    </el-dialog>
  </div>
</template>

<script>
/* import VDistpicker from "v-distpicker"; */
//import moment from 'moment'
import { timerfilter } from "../util/timerfilter";

export default {
  /*   components: {
    VDistpicker,
  }, */
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      guDataCount: 0,
      currentPage: 1,
      pageSize: 10,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      guData: [],
      viewguide: "",
      model: {
        province: "",
        city: "",
        area: "",
      },
      dialogVisible: false,
    };
  },

  methods: {
    async getMajor() {
      const getmajor = await this.$http.get("/major/getmajor");
      this.major = getmajor.data;
    },
    async getChannel(item) {
      const getchannel = await this.$http.get("/category/getchannel");
      this.channel = getchannel.data;
      //this.getlesson(item);
    },
    async getCourse(chID) {
      const getcourse = await this.$http.get("/category/getcourse", {
        params: { chID },
      });
      this.course = getcourse.data;
      this.getGuide(chID);
    },
    async getClass(coID) {
      const getclass = await this.$http.get("/category/getclass", {
        params: { coID },
      });
      this.shclass = getclass.data;
      this.getGuide(coID);
    },
    async getGuide() {
      try {
        const result = await this.$http.get("/guide/getguide", {
          params: {
            page: this.currentPage,
            size: this.pageSize,
            chID: this.model.chID,
            maID: this.model.maID,
            coID: this.model.coID,
            clID: this.model.clID,
            prCode: this.model.prCode,
            ciCode: this.model.ciCode,
            arCode: this.model.arCode,
          },
        });
        //console.log(result.data[0].result);
        this.guData = result.data[0].result;
        this.guDataCount = result.data[0].resultLength[0].totalCount;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async scanGuide(row) {
      this.dialogVisible = true;
      const result = await this.$http.get(
        "/guide/viewguide?_id=" + `${row._id}`
      );
      //console.log(result.data);
      this.viewguide = result.data;
    },
    async delGuide(row) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          return this.$http.get("/guide/delguide?_id=" + `${row._id}`);
        })
        .then((result) => {
          if (result.status === 203) {
            this.$message({
              type: "success",
              message: result.data.msg,
            });
          }

          this.getGuide();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    selectProvince({ code, value }) {
      this.model.province = value;
      this.model.prCode = code;
      //console.log({ code, value });
      this.getGuide();
    },
    selectCity({ code, value }) {
      this.model.city = value;
      this.model.ciCode = code;
      this.getGuide();
      //console.log({ code, value });
    },
    selectArea({ code, value }) {
      this.model.area = value;
      this.model.arCode = code;
      this.getGuide();
      //console.log({ code, value });
    },

    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
    //新闻分类选项
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getGuide(this.currentPage);
      //console.log(this.currentPage);
    },
    async thpre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async thnext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
    this.getGuide();
  },
};
</script>

<style></style>
